<template>
  <vx-card no-shadow>
    <h3>Changement de mot de passe</h3>

    <vs-input
      type="password"
      class="w-full mb-base"
      label-placeholder="Ancien mot de passe"
      v-model="current_password"
    />
    <vs-input
      type="password"
      class="w-full mb-base"
      label-placeholder="Nouveau mot de passe"
      v-model="new_password"
    />
    <vs-input
      type="password"
      class="w-full mb-base"
      label-placeholder="Confirmer le mot de passe"
      v-model="confirm_new_password"
    />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button color="primary" class="ml-auto mt-2" @click="changePass"
        >Sauvegarder</vs-button
      >
      <vs-button class="ml-4 mt-2" type="border" color="warning"
        >Réinitialiser</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import VueCookies from "vue-cookies";
export default {
	name: "ChangePassUserSettings",
	data() {
		return {
			current_password: "",
			new_password: "",
			confirm_new_password: "",
			apiUrl: this.$store.state.backendApiUrl,
			user: null
		};
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		}
	},
	created() {
		this.user = VueCookies.get("userInfo");
	},
	methods: {
		/**
		 * Call the api to change the password for the current user connected
		 */
		changePass() {
			if(
				this.current_password &&
        this.new_password &&
        this.confirm_new_password != ""
			) {
				if(this.new_password == this.confirm_new_password) {
					this.$http
						.post(this.apiUrl + "users/update/password", {
							id: this.user.id,
							currentPassword: this.current_password,
							newPassword: this.new_password
						})
						.then(res => {
							// Update the user data since the password changed
							this.user = res.data.data[0];
							this.$vs.notify({
								title: "Succès",
								text: "Le mot de passe a été mis à jour."
							});
							this.$store.dispatch("updateUserInfo", {password: res.data.data[0].password});
							this.$router.go(-1);
						})
						.catch(err => {
							this.$vs.notify({
								title: "Erreur",
								text: "Le mot de passe n'a pas été mis à jour.",
								color: "danger"
							});
							//console.log(err);
						});
				}
				else{
					this.$vs.notify({
						title: "Erreur",
						text: "Le nouveau de mot passe ne correspond pas.",
						color: "danger"
					});
				}
			}
			else{
				this.$vs.notify({
					title: "Erreur",
					text:
            "Remplissez les champs pour pouvoir modifier votre mot de passe",
					color: "danger"
				});
			}
		}
	}
};
</script>
